export { InjectionMode, Stylesheet, concatStyleSets, concatStyleSetsWithProps, fontFace, keyframes, mergeStyleSets, mergeStyles, } from '@fluentui/merge-styles';
//# sourceMappingURL=MergeStyles.js.map